package com.gsb.vyapar.bhagya.presentation.search.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.isBusinessDeleted
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.util.launchBusinessDetail
import com.gsb.vyapar.bhagya.presentation.business.view.BusinessCardFull
import com.gsb.vyapar.bhagya.presentation.common.edittext.SearchEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.presentation.search.util.queryString
import com.gsb.vyapar.bhagya.presentation.searchlist.util.showSearchBusinessList
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.splash
import org.jetbrains.compose.resources.painterResource

@Composable
fun SearchView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    var search by remember { mutableStateOf(TextFieldValue(uiState.searchUiState.queryString)) }
    val focusRequester = remember { FocusRequester() }
    val keyboardController = LocalSoftwareKeyboardController.current
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar(uiState.searchUiState.title)
            Column(Modifier.padding(all = 16.dp)) {
                SearchEditText(search, modifier = Modifier.focusRequester(focusRequester)) { value ->
                    search = value
                    queryString(search.text)
                }
                if (uiState.searchUiState.searchCategories.isEmpty() && uiState.searchUiState.searchSubCategories.isEmpty() && uiState.searchUiState.searchBusinessList.isEmpty()) {
                    Column(Modifier.fillMaxSize(), verticalArrangement = Arrangement.Center, horizontalAlignment = Alignment.CenterHorizontally) {
                        CommonImage(painterResource(splash), Modifier.width(150.dp).height(150.dp))
                        Spacer(Modifier.height(8.dp))
                        Text14RegularBB(text = "Search by Name/Pincode/Reg-Number/Category/SubCategory etc.", color = black)
                        Spacer(Modifier.height(8.dp))
                        Text14RegularB(text = "We couldn't find any matches for your search. Please try again with different keywords!", color = black)
                    }
                } else {
                    LazyColumn {
                        if (uiState.searchUiState.searchCategories.isNotEmpty()) {
                            item {
                                Spacer(Modifier.height(8.dp))
                                Text14RegularBB(text = "Category Result", color = black)
                                Spacer(Modifier.height(8.dp))
                            }
                            items(uiState.searchUiState.searchCategories) { category ->
                                Card(
                                    modifier = Modifier.fillMaxWidth().height(50.dp).clickable {
                                        showSearchBusinessList(category)
                                    },
                                    shape = RoundedCornerShape(8.dp),
                                    backgroundColor = offwhite,
                                ) {
                                    Box(contentAlignment = Alignment.Center) {
                                        Text14RegularB(text = category.name, color = black)
                                    }
                                }
                                Spacer(Modifier.height(8.dp))
                            }
                        }
                        if (uiState.searchUiState.searchSubCategories.isNotEmpty()) {
                            item {
                                Spacer(Modifier.height(8.dp))
                                Text14RegularBB(text = "SubCategory Result", color = black)
                                Spacer(Modifier.height(8.dp))
                            }
                            items(uiState.searchUiState.searchSubCategories) { subCategory ->
                                Card(
                                    modifier = Modifier.fillMaxWidth().height(50.dp).clickable {
                                        val selectedCategory = uiState.getCategories().getCategoriesList().find { it.id == subCategory.categoryId }
                                        showSearchBusinessList(selectedCategory, subCategory)
                                    },
                                    shape = RoundedCornerShape(8.dp),
                                    backgroundColor = offwhite,
                                ) {
                                    Box(contentAlignment = Alignment.Center) {
                                        Text14RegularB(text = subCategory.name, color = black)
                                    }
                                }
                                Spacer(Modifier.height(8.dp))
                            }
                        }
                        if (uiState.searchUiState.searchBusinessList.isNotEmpty()) {
                            item {
                                Spacer(Modifier.height(8.dp))
                                Text14RegularBB(text = "Business Result", color = black)
                                Spacer(Modifier.height(8.dp))
                            }
                            items(uiState.searchUiState.searchBusinessList) { businessOld ->
                                val business = getBusinessUiState().isBusinessFetched.value[businessOld.getId()] ?: businessOld
                                if (!business.isBusinessDeleted()) {
                                    BusinessCardFull(uiState, onTriggerEvent, business) {
                                        launchBusinessDetail(business)
                                    }
                                    Spacer(Modifier.height(8.dp))
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    LaunchedEffect(Unit) {
        focusRequester.requestFocus()
        search = search.copy(selection = TextRange(search.text.length))
        keyboardController?.show()
    }
}